import axiosConfig from "./axiosConfig";

const deleteGlobalState = async (
  authToken: string,
  stateId: string
): Promise<void> => {
  await axiosConfig.delete(`/global-state/${stateId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

export default deleteGlobalState;
